import { Modal, message, Button } from "antd";
import React, { useState, useEffect, useRef } from "react";
import { putRequest } from "../../service";
import { getChangedFields } from "../../utils/getChangedFields";

const IdentitiesEdit = (props) => {
  const { open, onRequestClose, employee } = props;
  const [form, setForm] = useState({
    nationalId: "",
    EOBI: "",
    NTN: "",
    employee_code: "",
    machineCode: "",
    passportNo: ""
  });
  const originalFormRef = useRef({});

  useEffect(() => {
    if (employee) {
      const initialData = {
        nationalId: employee.nationalId || "",
        EOBI: employee.EOBI || "",
        NTN: employee.NTN || "",
        employee_code: employee.employee_code || "",
        machineCode: employee.machineCode || "",
        passportNo: employee.passportNo || ""
      };
      setForm(initialData);
      originalFormRef.current = initialData;
    }
  }, [employee]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      const payload = getChangedFields(originalFormRef.current, form);
      if (Object.keys(payload).length === 0) {
        message.info("No changes to update");
        return;
      }
      const response = await putRequest(`/api/employees?employeeId=${employee._id}`, payload);
      if (response.message === 'Employee updated successfully (some related data could not be loaded)') {
        message.success('Employee updated successfully')
        onRequestClose();
      }
      else {
        message.error(response.message || "Employee not updated")
      }
    } catch (error) {
      console.error('Error updating employee:', error);
    }
  };

  return (
    <Modal
      title="Identity Information"
      open={open}
      onCancel={onRequestClose}
      footer={null}
      width={800}
    >
      <div className="flex items-start justify-between bg-white  h-[50vh] overflow-auto">
        <div className="bg-form-bg w-full rounded-md px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col gap-1">
              <label htmlFor="id" className="text-md">
                National ID
              </label>
              <input
                type="text"
                placeholder="National ID"
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="nationalId"
                onChange={handleChange}
                value={form.nationalId}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="id" className="text-md">
                EOBI No
              </label>
              <input
                type="text"
                placeholder="EOBI No"
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="EOBI"
                onChange={handleChange}
                value={form.EOBI}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="id" className="text-md">
                NTN No
              </label>
              <input
                type="text"
                placeholder="NTN No"
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="NTN"
                onChange={handleChange}
                value={form.NTN}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="id" className="text-md">
                Employee Code
                <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <input
                type="text"
                placeholder=""
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="employee_code"
                onChange={handleChange}
                value={form.employee_code}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="id" className="text-md">
                Attendance Machine Code
              </label>
              <input
                type="text"
                placeholder=""
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="machineCode"
                onChange={handleChange}
                value={form.machineCode}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="id" className="text-md">
                Passport No
              </label>
              <input
                type="text"
                placeholder="Passport No."
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="passportNo"
                onChange={handleChange}
                value={form.passportNo}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end gap-3 my-2">
        <Button onClick={onRequestClose} >Cancel</Button>
        <Button
          onClick={handleSubmit}
          type="primary"
          className="bg-primary text-white"
        >
          Update Identities
        </Button>
      </div>
    </Modal>
  );
};

export default IdentitiesEdit;
